import React, { Component } from 'react';
import PropTypes from "prop-types";
import {BeatLoader} from 'react-spinners';
import Modal from 'react-modal';
import {get, post,postResponse} from "../../../server/actions";
import NotificationSystem from 'react-notification-system';
import {_addNotificationError, buildGradeName,getMonthNameByNumber, _addNotification} from "../../../server/util";
import $ from 'jquery';
const download = require('downloadjs');
const modalStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '40%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};
class ManageLunchBal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            alertModalIsOpen:false,
            invalidStudentIds:[],
            InvalidProcessTypeStudentsIds:[],
            responseMessage:'',
            type:'Add'
        }
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
    exportAccountBal=()=> {
        const _self=this;
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let schoolId = userInfo.schoolId;
        get(`/${schoolId}/studentBalanceExport/${sessionStorage.getItem('schoolYearValue')}?access_token=`).then((response) => {
            if (!response.ok) {
                if(response.status===417){
                    return response.json();
                }
            }
            return response;
        }).then(res => {
            if(res.statusCode===417){
               // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            }else if(!res.statusCode===200){
                throw Error(res.errorMessage);
            }else{
                return res.blob();                
            } 
        }).then(blob => {
            let filename = 'Students Account Bal';
                download(blob,
                    filename + '.xls', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        }).catch(
            (error) => {
                let msg=''
                if(typeof error==='string'){
                    msg=error;
                }else{
                    msg=error.message;
                }
               _addNotificationError(msg,_self)
               this.setState({loading: false})
                //console.log('Get Excel File response', error)
            }
        )
    }
    handleSubmit=(e)=>{
        e.preventDefault();
        if(document.getElementById('mealFile').value.length<=0){
            return false;
        }
        let fileInput = document.getElementById('mealFile').files[0];
        var data = new FormData();
        data.append('file', fileInput);
        this.setState({loading: true})
         postResponse('/transactions/importStudentsBalance?mealSchoolId=' + sessionStorage.getItem("SchoolId")+"&schoolYear="+sessionStorage.getItem('schoolYearValue')+'&type='+this.state.type+'&access_token=', data).then((response) => {
       if (response.statusCode!=200) {
                throw Error(response.statusMessage);
            }
            return response;
        }).then(data => {
            console.log(data)
            let invalidIds=data.mapKeyVal.InvalidStudentIds
            let invalidTypeIds=data.mapKeyVal.InvalidProcessTypeStudentsIds
            invalidIds=(invalidIds||'').length>0?invalidIds:'';
            invalidTypeIds=(invalidTypeIds||'').length>0?invalidTypeIds:'';

            if(invalidIds.length>0 ||invalidTypeIds.length>0 ){
                this.setState({
                    alertModalIsOpen:true,
                    loading:false,
                    invalidStudentIds:invalidIds.split(','),
                    InvalidProcessTypeStudentsIds:invalidTypeIds.split(','),
                    responseMessage:data.statusMessage
                });
            }else{

                this.setState({
                    alertModalIsOpen:true,
                    loading:false,
                    invalidStudentIds:[],
                    InvalidProcessTypeStudentsIds:[],
                    responseMessage:data.statusMessage
                });
                _addNotification(data.statusMessage, this)
            }
                
        }).catch(
            (error) => {
                this.setState({loading: false})
                _addNotificationError(error.message, this)
                console.log('Cannot load meals', error)
            }
        );
    }
    render(){
        return(
        
            <section className="full-width clearfix">
                <div className="container">
                <NotificationSystem ref="notificationSystem"/>
                <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="row">
                            <div className="col-xs-12">
                                <div className="sectionTitle">
                                    <h2>
                                        <span>Import/Export Student Account Balance </span>
                                    </h2>

                                </div>
                            </div>

                        </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="tabCommon custom-tabCommon">
                            <ul className="nav nav-tabs" role="tablist">
                                <li role="presentation" className="active">
                                    <a href="#Section1" aria-controls="home"  role="tab" data-toggle="tab">Import Account Balance</a>
                                </li>
                                <li role="presentation">
                                    <a href="#Section2" aria-controls="profile" role="tab" data-toggle="tab">Export Account Balance</a></li>
                            </ul>

                            <div className="tab-content">
                                <div role="tabpanel" className="tab-pane active" id="Section1">
                                    <div className="row">
                                        <form onSubmit={(e) => this.handleSubmit(e)}>
                                            <div className="col-md-12 col-sm-12 col-xs-12 text-center createmenu-panel">
                                                <div className="panel panel-primary">
                                                    <div className="panel-heading text-center">
                                                        <h3 className="panel-title"> {'Import Account Balance'}</h3>
                                                    </div>
                                                    <div className="panel-body">
                                                        <div className="row">
                                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                                <div className="col-md-7 col-md-offset-3 col-sm-12 col-xs-12 text-center">
                                                                    <label className="control-label"> Import Student Account Balance </label>
                                                                </div>
                                                                <div className="col-md-7 col-md-offset-3 col-sm-12 col-xs-12 text-center">
                                                                    <label className="radio-inline">
                                                                        <input type="radio" name="type" value={'Add'} checked={this.state.type==='Add'} onChange={(e)=>{
                                                                            this.setState({type:e.target.value})
                                                                        }}  />Add Balance
                                                                    </label>
                                                                    <label className="radio-inline">
                                                                        <input type="radio" name="type" value={'Overwrite'} checked={this.state.type==='Overwrite'} onChange={(e)=>{
                                                                            this.setState({type:e.target.value})
                                                                        }} />Overwrite Balance
                                                                    </label>
                                                                </div>
                                                                <div className="uploadFileInfo col-md-12 col-sm-12 col-xs-12 createmenu-file-group">
                                                
                                                                    <div className="input-group col-md-7 col-md-offset-3 col-sm-12 col-xs-12">
                                                        
                                                                        <input type="file" className="form-control"
                                                                            style={{opacity: '1', zIndex: '0'}}
                                                                            id="mealFile" aria-describedby="basic-addon21"
                                                                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                                            onChange={(e)=>{
                                                                                let validExts = new Array(".xlsx", ".xls", ".csv");
                                                                                let fileExt = e.target.files[0].name.split('.').pop();
                                                                                const fileSize = e.target.files[0].size;
                                                                                const fileMb = fileSize / 1024 ** 2;
                                                                                if (validExts.indexOf('.'+fileExt) < 0) {
                                                                                    _addNotificationError("Invalid file format. Please select valid file format (" +
                                                                                        validExts.toString() + ")",this);
                                                                                    e.target.value='';
                                                                                return false;
                                                                                }else if(fileMb >= 2){
                                                                                    _addNotificationError("Please select a file less than 2MB.",this);
                                                                                    e.target.value='';
                                                                                    return false;
                                                                                }
                                                                                else return true;
                                                                        }}
                                                                            />
                                                                        <button id="OpenUpload"
                                                                                className="input-group-addon" onClick={() => {
                                                                            $('#mealFile').click()
                                                                        }}><i
                                                                            className="fa fa-upload"
                                                                            aria-hidden="true"/>
                                                                        </button>
                                                                    </div>
                                                
                                                                </div>
                                                                <div className="col-md-12 col-sm-12 col-xs-12 createmenu-link-group">
                                                                    <p className="input-group col-md-12 col-sm-12 col-xs-12">Upload student account balance data. Download&nbsp;<a
                                                                        href="https://s3.amazonaws.com/mealmanage-prod/SampleFiles/StudentBalanceImport.xlsx"
                                                                        download>Sample file</a>
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-7 col-md-offset-3 text-center">
                                                                    <button type="submit" id="submit" className="btn btn-sm btn-primary"><i
                                                                        className="fa fa-arrow-circle-right"></i><span>Proceed</span></button>
                                                                </div>                        
                                                            </div>                    
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div role="tabpanel" className="tab-pane" id="Section2">
                                    <div className="row">
                                        <div className="col-md-12 col-sm-12 col-xs-12 text-center createmenu-panel">
                                            <div className="panel panel-primary">
                                                <div className="panel-heading text-center">
                                                    <h3 className="panel-title"> {'Export Account Balance'}</h3>
                                                </div>
                                                <div className="panel-body">
                                                    <div className="row">
                                                        <div className="col-md-12 col-sm-12 col-xs-12 text-center">
                                                            <label className="control-label"> Export Student Account Balance </label>
                                                        </div>
                                                        <div className="col-md-12 col-sm-12 col-xs-12 text-center">
                                                            <button className="btn btn-warning btn-sm" 
                                                                         onClick={()=>{
                                                                            this.exportAccountBal()
                                                                        }}><i className="fa fa-file-excel-o"></i> Export</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
            <Modal isOpen={this.state.alertModalIsOpen} style={modalStyles} >            
                <div className="modal-body">
                    <div className="row">
                        {
                            this.state.invalidStudentIds.length<=0?
                            <div className="col-md-12 col-sm-12">
                                <p className="color-5 text-center" style={{
                                            fontSize: '13px',
                                            fontWeight: '600'
                                    }}>
                                    <strong>{this.state.responseMessage}</strong>
                                    </p>
                            </div> :
                            <div className="col-md-12 col-sm-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        <p className="color-5 text-center" style={{
                                            fontSize: '13px',
                                            fontWeight: '600'
                                        }}>
                                        <strong>
                                            {
                                                this.state.responseMessage
                                            }
                                        </strong>
                                        </p>
                                        <p className="color-1" style={{
                                            fontSize: '13px',
                                            fontWeight: '600'
                                        }}> <strong>Note:</strong> These below student id's does not exists in MealManage. Please check and make sure that you are passing valid students.</p>

                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <span style={{color:'red', textDecoration:'underline'}} >Invalid Student Id's:</span> <span className="pull-right">Count:{this.state.invalidStudentIds.length}</span>
                                        <div className="row" style={{overflowY:'scroll', height:'200px'}}>
                                        { this.state.invalidStudentIds.length>0?
                                            this.state.invalidStudentIds.map(item=>{
                                                return (<div className="col-md-4"><i className="fa fa-hand-o-right"></i> { item}</div>)
                                            }):<div className="col-md-12">No records found</div>
                                        }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className="modal-footer">
                    <div className="text-right">
                        <button type="button" className="btn btn-success btn-xs"
                                style={{ margin: '0 0 0 5px' }} onClick={()=>{
                                    this.setState({alertModalIsOpen:false},
                                        this.context.router.history.push('/schoolAdmin/paymentReports?opr=hist')
                                    )
                                }}
                                id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Ok
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    </section>)
    }
}
ManageLunchBal.contextTypes = {
    router: PropTypes.object.isRequired
}
export default ManageLunchBal


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/ManagePayments/ManageLunchBal.jsx